export var PlatformNotificationTypes;
(function (PlatformNotificationTypes) {
    PlatformNotificationTypes["MAINTENANCE"] = "MAINTENANCE";
    PlatformNotificationTypes["FEATURE"] = "FEATURE";
    PlatformNotificationTypes["SYSTEM_ERROR"] = "SYSTEM_ERROR";
    PlatformNotificationTypes["RELEASE_NOTE"] = "RELEASE_NOTE";
    PlatformNotificationTypes["GENERIC"] = "GENERIC";
})(PlatformNotificationTypes || (PlatformNotificationTypes = {}));
;
;
//# sourceMappingURL=notification.type.js.map